import React from 'react'
import { ExpectationSvg, RevenueSvg, RiskSvg } from '../svg'
import SplitText from "../../../common/SplitText";

export default function Disclaimer() {
    const [position, setPosition] = React.useState(window.innerWidth);

    React.useEffect(() => {
        window.onresize = function () {
            setPosition(window.innerWidth);
        };
    }, []);

    return (
        <div className='mt-[80px] sm:mt-[100px] relative bg-[#EDFAFE] py-[50px] sm:py-[70px] lg:py-[90px] px-[16px] sm:px-[24px] lg:px-[40px]'>
            <div className='flex justify-center'>
                <SplitText
                    text="Disclaimers"
                    tag="h2"
                    className='text-[28px] sm:text-[38px] lg:text-[46px] xl:text-[54px] text-[#0F0200] font-bold text-center'
                    delay={30}
                    duration={0.6}
                    ease="power3.out"
                    splitType="words, chars"
                    from={{ opacity: 0, y: 30 }}
                    to={{ opacity: 1, y: 0 }}
                    threshold={0.1}
                    rootMargin="-40px"
                    textAlign="center"
                />
            </div>
            <div className='mt-[40px] w-full px-[16px] sm:px-0 sm:w-11/12 max-w-[1360px] mx-auto grid md:grid-cols-3 gap-[20px] lg:gap-[30px] justify-center'>
                
                <div className='bg-white rounded-[24px] p-[28px] sm:p-[32px] border border-blue-100 shadow-card hover:shadow-card-hover hover:-translate-y-1 transition-all duration-300 flex flex-col items-center justify-start gap-[14px] text-center'>
                    <div className='p-3 bg-blue-50 rounded-2xl'>
                        <RiskSvg size={position < 645 ? "36" : "52"}/>
                    </div>
                    <h3 className='text-[#181F38] text-[20px] font-bold'>Investment Risk</h3>
                    <p className='text-[#475569] text-[14px] sm:text-[15px] font-normal leading-relaxed'>As with any business, there are inherent risks, including market conditions and competition. While our franchise model has been proven successful, results may vary by location and franchisee effort.</p>
                </div>

                <div className='bg-white rounded-[24px] p-[28px] sm:p-[32px] border border-blue-100 shadow-card hover:shadow-card-hover hover:-translate-y-1 transition-all duration-300 flex flex-col items-center justify-start gap-[14px] text-center'>
                    <div className='p-3 bg-blue-50 rounded-2xl'>
                        <RevenueSvg size={position < 645 ? "36" : "52"}/>
                    </div>
                    <h3 className='text-[#181F38] text-[20px] font-bold'>Revenue Projections</h3>
                    <p className='text-[#475569] text-[14px] sm:text-[15px] font-normal leading-relaxed'>Revenue and income projections provided are estimates based on average franchisee performance and do not guarantee fixed future earnings.</p>
                </div>

                <div className='bg-white rounded-[24px] p-[28px] sm:p-[32px] border border-blue-100 shadow-card hover:shadow-card-hover hover:-translate-y-1 transition-all duration-300 flex flex-col items-center justify-start gap-[14px] text-center'>
                    <div className='p-3 bg-blue-50 rounded-2xl'>
                        <ExpectationSvg size={position < 645 ? "36" : "52"}/>
                    </div>
                    <h3 className='text-[#181F38] text-[20px] font-bold'>Franchisee Expectations</h3>
                    <p className='text-[#475569] text-[14px] sm:text-[15px] font-normal leading-relaxed'>Franchisees must meet all initial investment costs and are expected to adhere to the quality and operating guidelines provided by Rainbow Trucks.</p>
                </div>

            </div>
        </div>
    )
}
